<template>
  <div :style="styles.renderingArea">
    <img v-gallery :src="src" :style="{width: (innerWidth - 20) + 'px', height: (innerHeight - 20) + 'px'}"/>
  </div>
</template>

<script>
export default {
  name: 'img-viewer',
  props: ['src'],
  data () {
    return {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      styles: {
        renderingArea: {
          background: '#f0f0f0',
          margin: '1rem 0'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/misc/components/ImgViewer.vue